<app-login *ngIf="isShowLogin" [byPassEmailPasswordReset]="byPassEmailPasswordReset"></app-login>
<app-register *ngIf="!isShowLogin"></app-register>
<app-loading-general></app-loading-general>
